import { ProblemDetailsError } from "./ApiHelpers";
export function createErrorFrom(error) {
    let errorMessage = "An error occurred during the purchase process.";
    if (error instanceof ProblemDetailsError) {
        errorMessage = JSON.stringify(error.details);
    }
    else if (error instanceof Error) {
        return error;
    }
    else if (typeof error === "object" && error !== null) {
        errorMessage = JSON.stringify(error);
    }
    else if (typeof error === "string") {
        errorMessage = error;
    }
    return Error(errorMessage);
}
//# sourceMappingURL=utils.js.map